// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const FIELD_MARGIN = token('space.050', '4px');

const LABEL_INPUT_MARGIN = token('space.050', '4px');

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Container = styled.div({
	display: 'flex',
	columnGap: `${FIELD_MARGIN}px`,
	justifyContent: 'space-between',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Inner = styled.div({
	display: 'flex',
	flexDirection: 'column',
	width: `calc(50% - ${FIELD_MARGIN})`,
	rowGap: `${LABEL_INPUT_MARGIN}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const Label = styled.label({
	font: token('font.body.UNSAFE_small'),
	fontWeight: token('font.weight.semibold'),
	color: token('color.text.subtlest'),
	marginTop: 0,
});
